import {
    apiGetClient,
    apiPostClient,
    apiPutClient,
    apiUserFormClient,
} from "../../../api/apiSvtAdminCore";

import { toast } from "react-toastify";

export const getAllAssessments = async () => {
    try {
        const response = await apiGetClient.get("assessments");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const saveAssessment = async (data) => {
    try {
        const response = await apiUserFormClient.post("assessments", data);
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const downloadBlankTemplate = async () => {
    try {
        const response = await apiGetClient.get(
            "assessments/download/blank-template",
             {
                responseType: "blob",
            }
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAssessmentDetails = async (assessmentMasterId, langId) => {
    try {
        const response = await apiGetClient.get(
            "assessments/assessmentdetails/" +
                assessmentMasterId +
                "/" +
                langId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const publishAssessment = async (data) => {
    try {
        const response = await apiPutClient.put("assessments", data);
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const updateAssessmentDetails = async (assessmentMasterId, data) => {
    try {
        const response = await apiPutClient.put(
            "assessments/" + assessmentMasterId,
            data
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const deleteQuestion = async (questionId) => {
    try {
        const response = await apiPostClient.delete(
            "assessments/question/" + questionId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createAssessment = async (data) => {
    try {
        const response = await apiPostClient.post(
            "assessments/createassessment",
            data
        );
        toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getVersions = async (templateMasterId, languageId) => {
    try {
        const response = await apiGetClient.get(
            `assessments/template-master/${templateMasterId}/language/${languageId}/versions`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};
